/* eslint-disable no-unsafe-optional-chaining */
import {useRouter} from 'next/router';
import useCommon from '@utils/hooks/common';
import Link from 'next/link';
import {langList, LANG_CODE, TABLET_BREAKPOINT, CURRENCIES} from '@constant/system';
import {Layout, Menu, MenuProps, Select, Spin, Tabs, notification} from 'antd';
import SearchIcon from '@public/images-mobile/header-mobile/search.svg';
import footer from '../footerItems';
import UserProfile from '../user-profile';
import styles from './styles';
import menus from '../menuItems';
import {isMerchantGateway} from '@utils/gateway/merchant-gateway';
import {useState} from 'react';
import useRequest from '@utils/hooks/useRequestCustom';
import announcementApi from '@utils/api/announcements.api';
import NewCustomizedModal from '@components/NewCustomizedModal';
import {useMediaQuery} from 'react-responsive';
import MenuButton from '@components/MenuButton';
// import {useSDK} from '@metamask/sdk-react';
import {disconnect} from '@wagmi/core';
import WalletConnectConfig from '@configs/WalletConnectConfig';
import authApi from '@utils/api/auth.api';
import PlayerAvatar from '@components/PlayerAvatar';
import BoxShadowButton from '@components/BoxShadowButton';
import CustomDivider from '@components/CustomDivider';
import CustomSelect from '@components/CustomSelect';
import CustomPopup from '@components/CustomPopup';
import {GAME_MODE} from '@constant/game';
import {termsAndConditions} from '../MobileHeader';
import {clearLocalStorageExceptDontShowDisclaimerAgain} from '@utils/index';

type ModalType = 'tnc' | 'announcement' | 'register' | 'login';

const {Option} = Select;
const {SubMenu, Item} = Menu;
const {Sider} = Layout;

const SiderBar = () => {
  const {t, permission, classes, language, user, system, theme} = useCommon({
    withStyles: styles,
    withTranslation: ['menu'],
    observers: ['user', 'permission', 'language', 'system'],
  });
  const router = useRouter();
  const searchBarIcon = <SearchIcon />;
  const isDesktop = theme?.currentStyleFormat?.id === 'desktop';
  // const {sdk, connected, connecting, provider, chainId} = useSDK();

  const {runAsync: getNonce} = useRequest(authApi.getNonce, {
    manual: true,
  });
  const {runAsync: loginWithMetaMask} = useRequest(authApi.loginWithMetaMask, {
    manual: true,
  });

  // const [collapsed, setCollapsed] = useState(false);
  const [isAnnouncementVisible, setIsAnnouncementVisible] = useState<boolean>(false);
  const [isTermAndConditionVisible, setIsTermAndConditionVisible] = useState<boolean>(false);
  const [modalType, setModalType] = useState<ModalType>(null);
  const [connectingMetaMask, setConnectingMetaMask] = useState<boolean>(false);

  // const connect = async () => {
  //   try {
  //     setConnectingMetaMask(true);
  //     const accounts = await sdk?.connect();
  //     console.log('accounts', accounts);
  //     if (accounts?.[0]) {
  //       const walletAddress = accounts[0];
  //       const result = (await getNonce({walletAddress})) || {};
  //       const {nonce} = result?.data || {};

  //       if (!nonce) {
  //         throw new Error('no nonce');
  //       }

  //       const signature: string = (await window.ethereum.request({
  //         method: 'personal_sign',
  //         params: [nonce, walletAddress],
  //       })) as string;

  //       const data = await loginWithMetaMask({walletAddress, signature});
  //       setConnectingMetaMask(false);

  //       if (data?.playerToken) {
  //         router.push({
  //           pathname: 'login-with-token',
  //           query: {
  //             playerToken: data.playerToken,
  //             isReload: false,
  //           },
  //         });
  //       } else {
  //         throw new Error('no player token');
  //       }
  //     }
  //   } catch (err) {
  //     console.warn('failed to connect..', err);

  //     notification.error({message: t('error'), description: err?.message});
  //     setConnectingMetaMask(false);
  //   } finally {
  //     setModalType(null);
  //   }
  // };

  const {
    data: announcementList,
    loading: isAnnouncementLoading,
    runAsync: getAnnouncementList,
  } = useRequest(token => announcementApi.getAnnouncementList(user?.getPlayerToken()), {
    manual: true,
  });

  const renderList = () => {
    if (announcementList?.length === 0 || !announcementList) return <div>{t('no_news')}</div>;

    return (
      <Tabs
        style={{height: '50vh'}}
        tabPosition="left"
        items={announcementList
          ?.filter(announcement => announcement?.active !== false)
          ?.sort(
            (announcementA, announcementB) => announcementA?.priority - announcementB?.priority
          )
          ?.map(announcement => {
            const {active, title, content, priority, from, to, id} = announcement;
            return {
              label: `${title}`,
              key: id,
              children: `${content}`,
            };
          })}
      />
    );
  };

  const onMenuClick: MenuProps['onClick'] = e => {
    console.log('e.key', e.key);
    e.domEvent.stopPropagation();
    if (e.key === '/game-recharge') {
      system?.showModalSheet('depositWithdraw');
    } else if (e.key === '/game-recharge?type=lucky-draw') {
      system?.showModalSheet('luckyDraw');
    } else {
      router.push(e.key);
    }
  };

  const getMenuItem = (mainPath, data) => {
    const {icon, label, path, needLogin = false, needFirstPartyGateway = false} = data;

    if (needLogin && !user?.isLogin()) {
      return null;
    }

    if (needFirstPartyGateway && user?.isThirdPartyGateway() && !isMerchantGateway()) {
      return null;
    }

    return (
      <Item className={classes.menuItem} key={`${mainPath}${path}`}>
        <Link href={`${mainPath}${path}`}>
          <div className={classes.menuIcon}>{icon || null}</div>
          <div className={classes.menuText}>{t(label)}</div>
        </Link>
      </Item>
    );
  };

  const getFooterItem = (domain, data, index) => {
    const {path, label, needFirstPartyGateway = false} = data;
    if (!user?.isLogin()) return null;
    if (needFirstPartyGateway && user?.isThirdPartyGateway() && !isMerchantGateway()) return null;

    return (
      <li key={`${domain}${path}`}>
        <Link href={`${domain}${path}`}>{t(`menu:${label}`)}</Link>
      </li>
    );
  };

  const handleLogout = async () => {
    user.updatePlayerToken('');

    // wallet connect sign out
    await disconnect(WalletConnectConfig);
    clearLocalStorageExceptDontShowDisclaimerAgain();
    router.push('/home');
  };

  return (
    <>
      <Sider
        // xs: '480px',
        // sm: '576px',
        // md: '768px',
        // lg: '992px',
        // xl: '1200px',
        // xxl: '1600px',
        breakpoint={'lg'}
        collapsedWidth={0}
        trigger={null}
        // original
        // width="fit-content"
        // style={{
        //   background: 'white',
        // }}
        // theme="dark"
        // collapsible
        collapsed={router.pathname === '/game-room'}
        // onCollapse={() => setCollapsed(!collapsed)}
        className={classes.sidebar}
        width={350}
        style={{zIndex: 1}}
      >
        <aside className={classes.asideContentContainer}>
          <section className={classes.upperPartSection}>
            <section className={classes.upperPartWrapper}>
              <section className={classes.userProfileSection}>
                {user?.isLogin() ? (
                  <UserProfile />
                ) : (
                  <div>
                    <div style={{display: 'flex', alignItems: 'center', marginBottom: 15, gap: 15}}>
                      <PlayerAvatar style={{flexShrink: 0}} icon={null} iconWidthPx={80} />
                      <div style={{width: '100%'}}>
                        <BoxShadowButton
                          className={classes.siderButton}
                          onClick={() => {
                            system?.showModalSheet('login');
                          }}
                        >
                          <img src="/icon/home/wallet.svg" style={{width: 20}} />
                          <div style={{width: '100%'}}>{t('connect_login')}</div>
                        </BoxShadowButton>
                      </div>
                    </div>
                  </div>
                )}
                {user?.isLogin() ? (
                  <section className={classes.siderButtonRow}>
                    <BoxShadowButton
                      className={classes.siderButton}
                      onClick={() => {
                        router.push({
                          pathname: '/game-list',
                          query: {
                            gameType: GAME_MODE.REGULAR,
                            currencyId: CURRENCIES.COIN,
                            isAllIn: false,
                          },
                        });
                      }}
                    >
                      <img style={{marginRight: 10}} src="/icon/menu/newGame.svg" />
                      <span style={{whiteSpace: 'normal'}}>{t('new_game')}</span>
                    </BoxShadowButton>
                    {!user?.isThirdPartyGateway() && (
                      <BoxShadowButton
                        className={classes.siderButton}
                        onClick={() => {
                          router.push('/referral');
                        }}
                      >
                        <img style={{marginRight: 10}} src="/icon/menu/inviteFriends.svg" />
                        <span style={{whiteSpace: 'normal'}}>{t('invite_friends')}</span>
                      </BoxShadowButton>
                    )}
                  </section>
                ) : null}
                <CustomDivider />
              </section>
            </section>
          </section>
          <section className={classes.navigationSection}>
            <nav>
              <Menu
                theme="dark"
                onClick={onMenuClick}
                defaultSelectedKeys={[`${router.asPath}`]}
                className={classes.menuInDrawer}
              >
                {menus.map(menuItem => getMenuItem('', menuItem))}
              </Menu>
            </nav>
          </section>
          <div className={classes.indentedSectionsContainer}>
            <CustomDivider />
            <section className={classes.languageSelectorSection}>
              <CustomSelect
                className={classes.languageSelector}
                defaultValue={language?.currentLanguage || LANG_CODE.ZH_HK}
                options={langList.map(lang => ({
                  label: (
                    <span style={{display: 'flex', alignItems: 'center'}}>
                      {
                        <img
                          className={classes.languageIcon}
                          src={lang.icon}
                          alt={lang.value}
                          width={15}
                          height={15}
                        />
                      }{' '}
                      {lang.label}
                    </span>
                  ),
                  value: lang.value,
                }))}
                onChange={val => {
                  language?.setLanguage(val);
                }}
                bordered={false}
              />
            </section>
            <section className={classes.footerSection}>
              <footer>
                <ul>{footer.map((footerItem, index) => getFooterItem('', footerItem, index))}</ul>
                <div
                  className={classes.footerButton}
                  onClick={() => setIsTermAndConditionVisible(!isTermAndConditionVisible)}
                >
                  {t(`tnc`)}
                </div>
                <div
                  className={classes.footerButton}
                  onClick={() => {
                    getAnnouncementList(user?.getPlayerToken());
                    setIsAnnouncementVisible(!isAnnouncementVisible);
                  }}
                >
                  {t('announcement')}
                </div>
                {user?.isLogin() && !user?.isThirdPartyGateway() ? (
                  <div
                    className={classes.footerButton}
                    onClick={() => {
                      handleLogout();
                    }}
                  >
                    {t('logout')}
                  </div>
                ) : null}
              </footer>
            </section>
          </div>
        </aside>
      </Sider>

      <CustomPopup
        // className={classes.announcementPopup}
        width={isDesktop ? '600px' : '300px'}
        open={isAnnouncementVisible}
        closable
        onCancel={() => {
          setIsAnnouncementVisible(false);
        }}
        title={t('announcement')}
      >
        {isAnnouncementLoading ? (
          <div className={classes.modalSpin}>
            <Spin />
          </div>
        ) : (
          renderList()
        )}
      </CustomPopup>
      <CustomPopup
        width={isDesktop ? '600px' : '85vw'}
        open={isTermAndConditionVisible}
        closable
        title={t('terms_and_conditions')}
        onCancel={() => {
          setIsTermAndConditionVisible(false);
        }}
      >
        <ol className={classes.modalBodyContent}>
          <ol className={classes.modalBodyContent}>
            {termsAndConditions.map((item, index) => (
              <li key={index}>
                <div style={{fontWeight: 600}}>{t(item.title)}</div>
                <p>{t(item.description)}</p>
              </li>
            ))}
          </ol>
        </ol>
      </CustomPopup>
    </>
  );
};

export default SiderBar;
